import React, { useRef, useState } from 'react';
import { computeTooltipPlacement } from './tooltipPositioning';

/**
 * Same layout as EngagerSliderRow: label + optional ? tooltip, control on the right.
 * Use for ordinal / categorical dropdowns in compact engagers.
 */
export default function EngagerSelectRow({
  id,
  label,
  tooltip,
  value,
  onChange,
  children,
  ariaLabel,
  isDefaultValue = false,
  defaultValue,
}) {
  const tooltipId = `${id}-tip`;
  const tip = tooltip != null && String(tooltip).trim() !== '';
  const tooltipWrapRef = useRef(null);
  const [tooltipPosClass, setTooltipPosClass] = useState('');
  const [tooltipInlineStyle, setTooltipInlineStyle] = useState(undefined);
  const showDefaultTone =
    isDefaultValue ||
    (defaultValue !== undefined &&
      defaultValue !== null &&
      String(value) === String(defaultValue));

  const updateTooltipPosition = () => {
    const placement = computeTooltipPlacement(tooltipWrapRef.current);
    setTooltipPosClass(placement.tooltipPosClass);
    setTooltipInlineStyle(placement.tooltipInlineStyle);
  };

  return (
    <div className="border-bottom-light nps-ups-step-row">
      <div className="grid-2-col-2-1 nps-ups-slider-grid">
        <div className="nps-ups-field-label">
          <span className="nps-ups-step-label">{label}</span>
          {tip ? (
            <span
              ref={tooltipWrapRef}
              className={`nps-ups-tooltip-wrap ${tooltipPosClass}`.trim()}
            >
              <button
                type="button"
                className="btn-small-round nps-ups-q"
                aria-describedby={tooltipId}
                aria-label={`Tip for ${label}`}
                onMouseEnter={updateTooltipPosition}
                onFocus={updateTooltipPosition}
              >
                ?
              </button>
              <span
                className="nps-ups-tooltip-bubble"
                id={tooltipId}
                role="tooltip"
                style={tooltipInlineStyle}
              >
                {tooltip}
              </span>
            </span>
          ) : null}
        </div>
        <div className="form-field-stack nps-ups-slider-col nps-ups-select-col">
          <select
            id={id}
            value={value}
            onChange={onChange}
            aria-label={ariaLabel || label}
            className={showDefaultTone ? 'nps-ups-select--default' : undefined}
          >
            {children}
          </select>
        </div>
      </div>
    </div>
  );
}
